module.exports = {
        srcSet: __webpack_public_path__ + "static/media/billcheckMobile-640.04355ce6.webp"+" 640w",
        images: [{path: __webpack_public_path__ + "static/media/billcheckMobile-640.04355ce6.webp",width: 640,height: 427}],
        src: __webpack_public_path__ + "static/media/billcheckMobile-640.04355ce6.webp",
        toString: function(){return __webpack_public_path__ + "static/media/billcheckMobile-640.04355ce6.webp"},
        
        width: 640,
        height: 427
      }